import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ANALYTICS_CHANNEL } from './types';
import { name as packageName, version as packageVersion } from '../version.json';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useCallback } from 'react';
export var useJqlPackageAnalytics = function useJqlPackageAnalytics(analyticsSource, packageName, packageVersion, analyticsChannel) {
  var _useAnalyticsEvents = useAnalyticsEvents(),
      createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  var createAndFireAnalyticsEvent = useCallback(function (payload) {
    var event = createAnalyticsEvent(_objectSpread(_objectSpread({}, payload), {}, {
      attributes: _objectSpread(_objectSpread({}, payload.attributes), {}, {
        analyticsSource: analyticsSource,
        packageName: packageName,
        packageVersion: packageVersion
      })
    }));
    event.fire(analyticsChannel);
  }, [createAnalyticsEvent, analyticsSource, packageName, packageVersion, analyticsChannel]);
  return {
    createAndFireAnalyticsEvent: createAndFireAnalyticsEvent
  };
};
export var useJqlEditorAnalytics = function useJqlEditorAnalytics(analyticsSource) {
  return useJqlPackageAnalytics(analyticsSource, packageName, packageVersion, ANALYTICS_CHANNEL);
};
export * from './types';
export * from './listener';